module.exports = __webpack_public_path__ + "media/assets/images/flags/ng-89c2e7bc4d2c737e96afe8dc0071d385.svg";